/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DocumentResponse
 */
export interface DocumentResponse {
    /**
     * 
     * @type {string}
     * @memberof DocumentResponse
     */
    documentId: string;
    /**
     * 
     * @type {string}
     * @memberof DocumentResponse
     */
    sourceFileId: string;
    /**
     * 
     * @type {string}
     * @memberof DocumentResponse
     */
    clientId: string | null;
    /**
     * 
     * @type {string}
     * @memberof DocumentResponse
     */
    fileName: string;
    /**
     * 
     * @type {string}
     * @memberof DocumentResponse
     */
    contentType: string;
    /**
     * 
     * @type {number}
     * @memberof DocumentResponse
     */
    fileSizeBytes: number;
    /**
     * 
     * @type {Date}
     * @memberof DocumentResponse
     */
    assignedAtUtc: Date;
    /**
     * 
     * @type {string}
     * @memberof DocumentResponse
     */
    assignedByUserCode: string;
    /**
     * 
     * @type {boolean}
     * @memberof DocumentResponse
     */
    isPreviewAvailable: boolean;
}

/**
 * Check if a given object implements the DocumentResponse interface.
 */
export function instanceOfDocumentResponse(value: object): value is DocumentResponse {
    if (!('documentId' in value) || value['documentId'] === undefined) return false;
    if (!('sourceFileId' in value) || value['sourceFileId'] === undefined) return false;
    if (!('clientId' in value) || value['clientId'] === undefined) return false;
    if (!('fileName' in value) || value['fileName'] === undefined) return false;
    if (!('contentType' in value) || value['contentType'] === undefined) return false;
    if (!('fileSizeBytes' in value) || value['fileSizeBytes'] === undefined) return false;
    if (!('assignedAtUtc' in value) || value['assignedAtUtc'] === undefined) return false;
    if (!('assignedByUserCode' in value) || value['assignedByUserCode'] === undefined) return false;
    if (!('isPreviewAvailable' in value) || value['isPreviewAvailable'] === undefined) return false;
    return true;
}

export function DocumentResponseFromJSON(json: any): DocumentResponse {
    return DocumentResponseFromJSONTyped(json, false);
}

export function DocumentResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DocumentResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'documentId': json['documentId'],
        'sourceFileId': json['sourceFileId'],
        'clientId': json['clientId'],
        'fileName': json['fileName'],
        'contentType': json['contentType'],
        'fileSizeBytes': json['fileSizeBytes'],
        'assignedAtUtc': (new Date(json['assignedAtUtc'])),
        'assignedByUserCode': json['assignedByUserCode'],
        'isPreviewAvailable': json['isPreviewAvailable'],
    };
}

export function DocumentResponseToJSON(json: any): DocumentResponse {
    return DocumentResponseToJSONTyped(json, false);
}

export function DocumentResponseToJSONTyped(value?: DocumentResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'documentId': value['documentId'],
        'sourceFileId': value['sourceFileId'],
        'clientId': value['clientId'],
        'fileName': value['fileName'],
        'contentType': value['contentType'],
        'fileSizeBytes': value['fileSizeBytes'],
        'assignedAtUtc': value['assignedAtUtc'].toISOString(),
        'assignedByUserCode': value['assignedByUserCode'],
        'isPreviewAvailable': value['isPreviewAvailable'],
    };
}

